import { IFile } from '@repo/toolkit/types'

import { ApiUrls } from '../../api/apis.config'
import { restApiClient } from '../../api/rest-api-client'
import { Files } from '../constants/files'
import {
  AttachmentType,
  SendEmailInput,
  SendEmailRequest
} from '../types/models/mail/create-mail-attachment'
import { uploadFile } from '../utils/functions/file.functions'

/**
 * Upload attachments and return the list of attached files
 * @param attachments - The list of attachments to upload
 * @returns The list of attached files
 */
export async function uploadAttachments(attachments?: IFile[]): Promise<AttachmentType[]> {
  const attachedFiles: AttachmentType[] = []

  if (!attachments || attachments.length === 0) return []

  for (const attachment of attachments) {
    const file = await uploadFile(Files.EMAIL_ATTACHMENTS, attachment)
    if (file) attachedFiles.push({ name: file?.name, url: file?.path })
  }

  return attachedFiles
}

/**
 * Send email base request
 * @param url - The API URL
 * @param input - The input data
 * @returns The response from the API
 */
export async function sendEmail<TResponse = never, T extends object = object>(
  url: ApiUrls,
  input: SendEmailInput<T>
) {
  const attachments = await uploadAttachments(input.attachments)

  return restApiClient.url(url).post<TResponse, SendEmailRequest<T>>({
    ...input,
    attachments
  })
}
